import * as yup from 'yup';
import { interpolate } from '@discover-frontend/utils';

import translations from 'src/lang';

const MIN_PROMPT_WORDS = 5;

const countWords = (value: string | undefined): number => {
  if (value == null || value === '') return 0;

  return value.trim().split(/\s+/).filter(Boolean).length;
};

const { COMMON, STANLEY_QUERY } = translations['en-US'];

export const stanleyQueryPanelContainerSchema = yup.object().shape({
  user_prompt: yup
    .string()
    .trim()
    .required(COMMON.ERROR_MESSAGES.MANDATORY_FIELD)
    .test(
      'min-words',
      interpolate(STANLEY_QUERY.MODAL.MIN_WORDS, { min: MIN_PROMPT_WORDS }),
      (value) => countWords(value) >= MIN_PROMPT_WORDS
    ),
});
